/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Nav from "../nav/Nav"
import Header from "../header/header"
import Footer from "../footer/footer"
import "./layout.css"
import Popup from "../popup/popup"
import { HeaderContext } from "../../context/header-context"
const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const { showPopup, togglePopup } = React.useContext(HeaderContext)

  return (
    <main className="flex flex-col">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <Popup togglePopup={togglePopup} showPopup={showPopup} />
      <Nav></Nav>

      <div className={`flex flex-col flex-1`}>{children}</div>
      <Footer />
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
